export const GaEventCategoryConstants = {
  Account: "Account"
}